import { cn } from "@/lib/utils";
import React from "react";
import { useNavigate } from "react-router-dom";

type Props = {
  title: string;
  groupName?: string;
  icon: React.ReactNode;
  iconBackgroundColor?: string;
  baseRoute?: string;
};

const ReportTitle = (props: Props) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (props.baseRoute) {
      navigate(props.baseRoute);
    }
  };
  return (
    <div className="flex gap-[12px] items-center">
      <div
        className="flex w-8 h-8 justify-center items-center rounded-[8px] squircle-mask"
        style={{ backgroundColor: props.iconBackgroundColor }}
      >
        {props.icon}
      </div>
      <div>
        <span
          onClick={handleClick}
          className={cn(
            "text-brand-primary-new text-ellipsis text-[18px] font-normal leading-[30.651px] tracking-[0.36px]",
            props.baseRoute && "cursor-pointer",
          )}
        >
          {props.title}
        </span>
        {props.groupName && (
          <span className="overflow-hidden -webkit-box-orient-vertical -webkit-line-clamp-1 text-[rgba(2,24,89,0.40)] text-ellipsis text-[18px] font-normal leading-[30.651px] tracking-[0.36px]">
            {" / " + props.groupName}
          </span>
        )}
      </div>
    </div>
  );
};

export default ReportTitle;
